var CaseWorldController = require('@thomann/caseconfigurator').Controller;
var BuilderApi = require('@thomann/caseconfigurator').BuilderApi;
var requestUpdates = require('./lib/requestUpdates');

//import Provider from '../lib/components/Provider.jsx'

var caseWorldController;
var data;
var basePath;

function bootstrap(initialData){
    data = initialData;
    var viewWidth = 684;  //540;
    var viewHeight = 465; //367;
    basePath = '/wp-content/themes/megacase/img/static/tr/js/caseconfigurator/';

    caseWorldController = new CaseWorldController({
        data,
        viewHeight,
        viewWidth,
        basePath
    });
    preloadPossibleParts(data, basePath);
    loadCasefactory();
}

function loadCasefactory () {
    var $3DContainer = $('[data-3d-container]');
    var $hideOverlay = $3DContainer.find('[data-hide-overlay]');

    if (!window.Float32Array) {
        $3DContainer.addClass('fallback');
        $3DContainer.addClass('nowebgl');
    }

    //$hideOverlay.doProgress('black', function (def) {
        $hideOverlay.show();
        caseWorldController.load($3DContainer);
        caseWorldController.getCaseWorldView().once('WorldCreated', function () {
            caseWorldController.emit('init');
            //def.resolve();
            $hideOverlay.hide();
        });
    //});
}

function preloadPossibleParts(data, path) {
    setTimeout(() =>{
        // TODO avoid network requests alltogether (this just uses the browser cache)
        data.possibleParts.forEach(function(part) {
            if(part.file) {
                var FILE_PATH = path + '3DModels/';

                var loader = new THREE.OBJMTLLoader();
                loader.load(FILE_PATH + part.file, FILE_PATH + part.textureFile);

                /* TODO: lib update
                var mtlLoader = new THREE.MTLLoader();

                mtlLoader.load( FILE_PATH + part.textureFile, function( materials ) {

                    //materials.preload();

                    var objLoader = new THREE.OBJLoader();

                    objLoader.setMaterials( materials );

                    objLoader.load( FILE_PATH + part.file, function ( object ) {

                    } );
                });
                */
            }
        });
    }, 10000);
}

function activateOption(option){
    caseWorldController.activateOption();
    requestUpdates(BuilderApi.createUpdateOptionObject(data.case.id, option, 'Ja'), onNewData);
}
function deactivateOption(option) {
    caseWorldController.deactivateOption(data.case.id, option)
    requestUpdates(BuilderApi.createUpdateOptionObject(data.case.id, option, 'Nein'), onNewData);
}

function removeRollsOrFeeds (part) {
    caseWorldController.removeRollsOrFeeds(part.category, data.case.id);
    requestUpdates(BuilderApi.createUpdatePartObject(null, part.category, data.case.id), onNewData);
}

function addRollsOrFeeds(part) {
    caseWorldController.addRollsOrFeeds(data.case.id, part.id, part.category, part.file, part.textureFile, part.normalMaps);
    requestUpdates(BuilderApi.createUpdatePartObject(part.id, part.category, data.case.id), onNewData);
}

function updateKeyboard (keyboardId, keyboardAndModel) {
    caseWorldController.updateKeyboard();
    requestUpdates(BuilderApi.createUpdateKeyboardObject(keyboardId, keyboardAndModel, data.case.id), onNewData);
}

function scaleCaseHeightTo(newHeight) {
    caseWorldController.scaleCaseHeightTo(newHeight,data.case.id);
    requestUpdates(BuilderApi.createUpdateDimesionObject(newHeight, 'height', data.case.id), onNewData);

}
function scaleCaseLengthTo(newLength) {
    caseWorldController.scaleCaseLengthTo(newLength, data.case.id);
    requestUpdates(BuilderApi.createUpdateDimesionObject(newLength, 'length', data.case.id), onNewData);

}
function scaleCaseDimensionToAndRequestUpdates(dimension, value, caseId) {
    if(dimension=="height_unit"){
        scaleCaseDimensionTo("height", value*45, caseId);
    }else {
        scaleCaseDimensionTo(dimension, value, caseId);
    }
    requestUpdates(BuilderApi.createUpdateDimesionObject(value, dimension, data.case.id), onNewData);
}

function scaleCaseDepthTo (newDepth){
    caseWorldController.scaleCaseDepthTo(newDepth, data.case.id);
    requestUpdates(BuilderApi.createUpdateDimesionObject(newDepth, 'depth', data.case.id), onNewData);

}

function scaleCaseDimensionTo (dimension, value){
    if(dimension == 'depth'){
        caseWorldController.scaleCaseDepthTo(value, data.case.id);
    }else if(dimension == 'height') {
        caseWorldController.scaleCaseHeightTo(value, data.case.id);
    }else{
        caseWorldController.scaleCaseLengthTo(value, data.case.id);
    }
}

function changeElementInCaseWorld(partId, category, file, textureFile, normalMaps,  on, needUpdate, invisiblePart) {
    caseWorldController.changeElement(partId, category, file, textureFile, normalMaps, on);
    caseWorldController.prepareForUpdate();
    requestUpdates(BuilderApi.createUpdatePartObject(partId, category, data.case.id), callback);

    function callback(newData){
        if (invisiblePart && partId && category) {
            caseWorldController.caseWorldView.setInvisiblePart(category, partId);
        }
        if(!needUpdate){
            caseWorldController.endAction();
        }

        onNewData(newData);
    }
}

function onNewData(newData) {

    if ( newData.success === undefined ) {
        data = newData;
    }
    caseWorldController.performUpdate(data);
    caseWorldController.emit('caseUpdated', data);
}


function getCaseWorldController(){
    return caseWorldController;
}

function getData() {
    return data;
}

function getBasePath() {
    return basePath;
}

module.exports = {
    bootstrap,
    getCaseWorldController,
    getData,
    getBasePath,
    action: {
        changeElementInCaseWorld,
        scaleCaseDimensionTo,
        scaleCaseDepthTo,
        scaleCaseLengthTo,
        scaleCaseHeightTo,
        updateKeyboard,
        addRollsOrFeeds,
        removeRollsOrFeeds,
        deactivateOption,
        activateOption,
        scaleCaseDimensionToAndRequestUpdates
    }
};


// WEBPACK FOOTER //
// ./js/caseconfigurator/casefactory/casefactory.js